import React, { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import DatagridRow from './DatagridRow';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import {
  setSymbolActive,
  setSymbolScroll,
} from '../../containers/client/actions';

import { isMobile } from 'react-device-detect';

import * as _ from 'lodash'
import { makeGetCategory } from '../../lib/selector';
import { saveState } from '../../lib/storages';

function Datagrid(props) {
  const dispatch = useDispatch();
  const [starredProjects, setStarredProjects] = useState([]);

  useEffect(() => {
    setStarredProjects(props.resource);
  }, [props.resource]);

  useEffect(() => {
    scrollTo(props.symScroll);
    dispatch(setSymbolScroll(null));
  }, [props.symScroll]);

  const scrollTo = (id) => {
    let _rootRow = document.getElementById(id + 'row');
    if (_rootRow) {
      _rootRow.scrollIntoView();
      _rootRow.classList.add('bg-active');
      setTimeout(() => {
        if (_rootRow) _rootRow.classList.remove('bg-active');
      }, 1500);
    }
  };

  const handleOpenModal = (sym) => {
    dispatch(setSymbolActive(sym));
  };

  const memoizedCallback = useCallback((state) => onDragEnd(state), [
    starredProjects,
  ]);

  const onDragEnd = (result) => {
    const { destination, source, reason } = result;
    console.log(result);
    // Not a thing to do...
    if (!destination || reason === 'CANCEL') {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    // console.log(starredProjects);

    const _starredProjects = Object.assign([], starredProjects);
    const project = starredProjects[source.index];
    _starredProjects.splice(source.index, 1);
    _starredProjects.splice(destination.index, 0, project);

    // console.log(_starredProjects);
    setStarredProjects(_starredProjects);
    // save 
    const _symToSort = _.map(_starredProjects, 'sym')
    console.log('symToSort', _symToSort);
    // store to local storage
    saveWatchListToStore(_symToSort)
  };

  const saveWatchListToStore = symToSort => {
    const { category, categoryId } = props;
    if(!categoryId) return;

    category.forEach((element) => {
      if (element.id === categoryId) {
        element.value = symToSort
      }
    });

    saveState('category', category);
  }

  const { children, className, isPc, isRoom } = props;
  // console.log('isMobile', isMobile)
  if (!isMobile)
    return (
      <DragDropContext onDragEnd={memoizedCallback}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <table
              ref={provided.innerRef}
              className={className + ''}
              {...provided.droppableProps}
            >
              <colgroup>
                <col width="5.5%"></col>
                {/** sym */}
                <col width="3.4%"></col>
                {/** tc */}
                <col width="3.4%"></col>
                {/** tran */}
                <col width="3.4%"></col>
                {/** san */}
                <col width="3.4%"></col>
                {/** gia 3 */}
                <col width="3.9%"></col>
                {/** kl 3 */}
                <col width="3.4%"></col>
                {/** giá 2 */}
                <col width="3.9%"></col>
                {/** kl 2 */}
                <col width="3.4%"></col>
                {/** gia 1 */}
                <col width="3.9%"></col>
                {/** kl 1 */}
                <col width="3.4%"></col>
                {/** gia khop */}
                <col width="4.4%"></col>
                {/** kl khop */}
                <col width="3.4%"></col>
                {/** +/- */}
                <col width="3.4%"></col>
                {/** gia 1 */}
                <col width="3.9%"></col>
                {/** kl 1 */}
                <col width="3.4%"></col>
                {/** gia 2 */}
                <col width="3.9%"></col>
                {/** kl 2 */}
                <col width="3.4%"></col>
                {/** gia 3 */}
                <col width="3.9%"></col>
                {/** kl 3 */}
                <col width="6.2%"></col>
                {/** tong kl */}
                <col width="3.8%"></col>
                {/** cao */}
                <col width="3.4%"></col>
                {/** thap */}
                <col width="3.4%"></col>
                {/** tb */}
                <col width="3.5%"></col>
                {/** nn mua */}
                <col width="3.5%"></col>
                {/** nn ban */}
              </colgroup>
              {children && (
                <thead style={{ borderBottom: '1px solid #42465b' }}>
                  {children}
                </thead>
              )}
              <tbody>
                {starredProjects &&
                  !!starredProjects.length &&
                  starredProjects.map((item, idx) => {
                    return (
                      <Draggable
                        draggableId={item.sym + '' + idx}
                        index={idx}
                        key={item.sym + '' + idx}
                      >
                        {(provided, snapshot) => (
                          <DatagridRow
                            forwardRef={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(
                              snapshot.isDragging,
                              provided.draggableProps.style
                            )}
                            record={item}
                            isPc={isPc}
                            isRoom={isRoom}
                            handleOpenModal={handleOpenModal}
                          />
                        )}
                      </Draggable>
                    );
                  })}
                {provided.placeholder}
              </tbody>
            </table>
          )}
        </Droppable>
      </DragDropContext>
    );

  return (
    <table className={className + ''}>
      <colgroup>
        <col width="5.5%"></col>
        {/** sym */}
        <col width="3.4%"></col>
        {/** tc */}
        <col width="3.4%"></col>
        {/** tran */}
        <col width="3.4%"></col>
        {/** san */}
        <col width="3.4%"></col>
        {/** gia 3 */}
        <col width="3.9%"></col>
        {/** kl 3 */}
        <col width="3.4%"></col>
        {/** giá 2 */}
        <col width="3.9%"></col>
        {/** kl 2 */}
        <col width="3.4%"></col>
        {/** gia 1 */}
        <col width="3.9%"></col>
        {/** kl 1 */}
        <col width="3.4%"></col>
        {/** gia khop */}
        <col width="4.4%"></col>
        {/** kl khop */}
        <col width="3.4%"></col>
        {/** +/- */}
        <col width="3.4%"></col>
        {/** gia 1 */}
        <col width="3.9%"></col>
        {/** kl 1 */}
        <col width="3.4%"></col>
        {/** gia 2 */}
        <col width="3.9%"></col>
        {/** kl 2 */}
        <col width="3.4%"></col>
        {/** gia 3 */}
        <col width="3.9%"></col>
        {/** kl 3 */}
        <col width="6.2%"></col>
        {/** tong kl */}
        <col width="3.8%"></col>
        {/** cao */}
        <col width="3.4%"></col>
        {/** thap */}
        <col width="3.4%"></col>
        {/** tb */}
        <col width="3.5%"></col>
        {/** nn mua */}
        <col width="3.5%"></col>
        {/** nn ban */}
      </colgroup>
      {children && <thead className="bb-1-haft ">{children}</thead>}
      <tbody>
        {starredProjects &&
          !!starredProjects.length &&
          starredProjects.map((item, idx) => {
            return (
              <DatagridRow
                key={item.sym + '' + idx}
                record={item}
                isPc={isPc}
                isRoom={isRoom}
                handleOpenModal={handleOpenModal}
              />
            );
          })}
      </tbody>
    </table>
  );
}

const mapStateToProps = (state) => {
  // console.log(state.client)
  const getCategory = makeGetCategory();

  return {
    symScroll: state.client.symbolScroll,
    category: getCategory(state),
  };
};

export default connect(mapStateToProps)(Datagrid);

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  ...draggableStyle,
});
